import userGWFragments from '@shared/hooks/usegwFragments'
import { secureLocalStorageGet } from '../../helpers/index'
import { http } from '../http'

export const getTrustedPersonList = async (): Promise<any[]> => {
  const userFragments = userGWFragments()

  const { data } = await http.post<any>(
    `gateway/${userFragments.customerNo}/inquiry`,
    {
      url: '/ib/order/card/salary/trusted-person/get-all',
      data: userFragments,
    }
  )

  if (data.data.code !== 200) {
    throw new Error(data.data.message);
  }

  return data.data.data
}

export const updateTrustedPersonList = async (req): Promise<any[]> => {
  const userFragments = userGWFragments()

  const { data } = await http.post<any>(
    `gateway/${userFragments.customerNo}/inquiry`,
    {
      url: '/ib/order/card/salary/trusted-person/update',
      data: {
        ...userFragments,
        ...req,
      },
    }
  )

  if (data.data.code !== 200) {
    throw new Error(data.data.message);
  }

  return data.data.data
}

export const deleteTrustedPersonList = async (id: number): Promise<any[]> => {
  const userFragments = userGWFragments()

  const { data } = await http.post<any>(
    `gateway/${userFragments.customerNo}/inquiry`,
    {
      url: '/ib/order/card/salary/trusted-person/delete',
      inqTypeCode: null,
      data: {
        ...userFragments,
        id,
      },
    }
  )

  if (data.data.code !== 200) {
    throw new Error(data.data.message);
  }

  return data
}

export const getTrustedPersonByPin = async (pin: string): Promise<any> => {
  const userFragments = userGWFragments()

  const { data } = await http.post<any>(
    `gateway/${userFragments.customerNo}/inquiry`,
    {
      url: '/ib/order/card/salary/trusted-person/by-pin',
      inqTypeCode: null,
      data: {
        ...userFragments,
        pin,
      },
    }
  )

  if (data.data.code !== 200) {
    throw new Error(data.data.message);
  }

  return data.data.data;
}
